import React from "react";
import { SvgIcon, SvgIconProps } from "@mui/material";
const AppIconsMenuBurger = React.forwardRef((props: SvgIconProps, ref: any) => {
  return (
    <SvgIcon {...props} ref={ref}>
      <g fill="currentColor">
        <path d="M22.7978249,3.0644441l-21.7112026.0139964C-.0788212,3.4437532-.0130229,5.0250678,1.1937138,5.2692018l21.6041111-.0013094c1.2706261-.2107201,1.2700577-1.9930782,0-2.2034483Z" />
        <path d="M22.8402252,18.7296124l-21.753603.0151787c-1.1654426.3653183-1.0996444,1.9466267.1070924,2.1907654l21.6465106-.0001278c1.2137508-.2650986,1.2138653-1.9406528,0-2.2058163Z" />
        <path d="M1.1937138,13.1023788h21.6131086c1.2582979-.2537346,1.2583923-1.95228,0-2.2060719l-21.7202002.0153103c-1.1654426.3653221-1.0996444,1.9466228.1070915,2.1907616Z" />
      </g>
    </SvgIcon>
  );
});

export default AppIconsMenuBurger;
